export default __webpack_public_path__ + "static/media/download1.3457111b.svg";